import { UntypedFormControl, UntypedFormGroup, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {
    NAME_CHAR_VALIDATION_REGEX,
    ORGANISATION_CHAR_VALIDATION_REGEX,
    URL_VALIDATION_REGEX
} from './constants';
import { environment } from './environment';

export function emailValidator(control: UntypedFormControl): { [s: string]: boolean } {
    if (
        // yeah... sure...
        !control.value.match(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
        return { invalidEmail: true };
    }
}

function firstNameLengthValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (control.value.length > 60) {
        return { firstnamelength: true };
    }
}

function firstNameCharacterValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (!control.value.match(NAME_CHAR_VALIDATION_REGEX)) {
        return { firstNameInvalidCharacter: true };
    }
}

function lastNameLengthValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (control.value.length > 60) {
        return { lastnamelength: true };
    }
}

function lastNameCharacterValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (!control.value.match(NAME_CHAR_VALIDATION_REGEX)) {
        return { lastNameInvalidCharacter: true };
    }
}

function passwordLengthValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (control.value.length < 12) {
        return { passwordlength: true };
    }
}

function passwordSpecialCharValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (!control.value.match(environment.specialCharacterRegex)) {
        return { passwordSpecialChar: true };
    }
}

function passwordNumberValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (!control.value.match(/[0-9]+/)) {
        return { passwordNumber: true };
    }
}

function passwordNoWhitespaceValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (!control.value.match(/^\S*$/)) {
        return { passwordContainsWhitespace: true };
    }
}

function confirmPasswordValidator(group: UntypedFormGroup): { [s: string]: boolean } {
    if (
        group.controls.password.value !== group.controls.confirmpassword.value
    ) {
        return { notEqual: true };
    }
}

function agbAcceptionValidator(control: UntypedFormControl): { [s: string]: boolean } {
    if (control.dirty && !control.value) {
        return { agbAcception: true };
    }
}

function positonLengthValidator(control: UntypedFormGroup): { [s: string]: boolean } {
    if (control.value.length > 60) {
        return { positionLength: true };
    }
}

function urlLengthValidator(control: UntypedFormGroup): { [s: string]: boolean } {
    if (!control.value || control.value.trim().length === 0) return null;
    if (control.value.length > 60) {
        return { websiteLength: true };
    }
    return null;
}

function urlFormatValidator(control: UntypedFormControl): { [s: string]: boolean } {
    if (!control.value) return null;
    
    const trimmed = control.value.trim();
    if (trimmed.length === 0) return { invalidUrl: true };
    if (!trimmed.match(URL_VALIDATION_REGEX)) {
        return { invalidUrl: true };
    }
    return null;
}

function organizationLengthValidator(control: UntypedFormGroup): {
    [s: string]: boolean;
} {
    if (control.value.length > 60) {
        return { organizationLength: true };
    }
}

function organizationCharacterValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (!control.value.match(ORGANISATION_CHAR_VALIDATION_REGEX)) {
        return { organizationInvalidCharacter: true };
    }
}

function positionCharacterValidator(control: UntypedFormControl): {
    [s: string]: boolean;
} {
    if (
        !control.value.match(NAME_CHAR_VALIDATION_REGEX) &&
        control.value.length > 0
    ) {
        return { positionInvalidCharacter: true };
    }
}

export function streetValidator(control: UntypedFormControl): { [s: string]: boolean } {
    const invalidChar: RegExp = /[<>{}\[\]\\]/g;
    if (control.value && control.value.match(invalidChar)) {
        return { specialCharFound: true };
    }
    return null;
}

export const VALIDATORS = {
    email: Validators.compose([Validators.required, emailValidator]),
    firstname: Validators.compose([
        Validators.required,
        firstNameLengthValidator,
        firstNameCharacterValidator
    ]),
    lastname: Validators.compose([
        Validators.required,
        lastNameLengthValidator,
        lastNameCharacterValidator
    ]),
    password: Validators.compose([
        Validators.required,
        passwordLengthValidator,
        passwordSpecialCharValidator,
        passwordNumberValidator,
        passwordNoWhitespaceValidator
    ]),
    agbAcception: agbAcceptionValidator,
    registryForm: confirmPasswordValidator,
    organization: Validators.compose([
        Validators.required,
        organizationLengthValidator,
        // organizationCharacterValidator
    ]),
    position: Validators.compose([
        positonLengthValidator,
        positionCharacterValidator
    ]),
    website: Validators.compose([urlLengthValidator, urlFormatValidator])
};

/**
 * Custom error state matcher for text inputs that checks for length and validation errors.
 */
export class CustomTextErrorStateMatcher implements ErrorStateMatcher {
    constructor(private maxLength: number) { }

    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const hasLengthError = control?.value?.length > this.maxLength;
        const hasNormalError = control?.invalid && (control?.dirty || control?.touched);

        return !!(hasLengthError || hasNormalError);
    }
}

export class MinLengthErrorStateMatcher implements ErrorStateMatcher {
    constructor(private maxLength: number) { }

    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const hasMaxLengthError = control?.value?.length > this.maxLength;

        const hasMinLengthError = (control?.value?.length < 2) && (control?.dirty || control?.touched);

        const hasOtherErrors = control?.invalid && (control?.dirty || control?.touched) &&
            !(control?.value?.length < 2);

        return !!(hasMaxLengthError || hasMinLengthError || hasOtherErrors);
    }
}